
import {
    EDIT_JOB_REQUEST,
    EDIT_JOB_SUCCESS,
    EDIT_JOB_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

    export const EditJobFormAction = (data,navigate) => {
    return function (dispatch) {
      dispatch({
        type: EDIT_JOB_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/update_jobs`,
        method: "PUT",
        data:data,
        headers: {
        //   "content-type": "application/json",
        "Content-Type": "multipart/form-data",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(EditJobFormPre(res.data,navigate));
       
        })
        .catch((error) => {
          dispatch({
            type: EDIT_JOB_FAIL,
            payload: false,
            error: error,
            createJob: error.success,
            msg: "Failed to create user registration",
          });
          toast.error(error.msg);
        });
    };
  };
  
  export const EditJobFormPre = (data,navigate) => {
    toast.success("Job Updated Successfully!");
    setTimeout(() => {
    //   window.location.href = "/posted_jobs";
    navigate('/posted_jobs')
  },2000);
    return {
      type: EDIT_JOB_SUCCESS,
      createJob: data.status.message,
      result: data,
      payload: false,
      msg: data.status.message,
    };
  };